export default function setAuthComplete(): void {
  const url = new URL(window.location.href);
  url.searchParams.set('authComplete', 'true');
  window.history.replaceState('', '', url.search);
}
